import React from 'react';

export default function Best() {
  return (
    <div className="best-main mt-8 md:mt-0 min-h-screen flex items-center justify-center pt-20 pb-24 md:pb-20 mb-6">
      <div className="relative w-full max-w-5xl mx-auto px-6">
        {/* Starfield */}
        {/* Decorative blurred + lined backdrop (subtle) */}
        <div aria-hidden style={{ position: 'absolute', inset: 0, zIndex: -2, pointerEvents: 'none', borderRadius: 20, overflow: 'hidden' }}>
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(16,10,6,0.08), rgba(106,49,10,0.04))', opacity: 1 }} />
          <div style={{ position: 'absolute', inset: 0, background: 'repeating-linear-gradient(90deg, rgba(239,167,79,0.06) 0 1px, transparent 1px 24px)', mixBlendMode: 'overlay', opacity: 0.9 }} />
          <div style={{ position: 'absolute', inset: 0, WebkitBackdropFilter: 'blur(4px)', backdropFilter: 'blur(4px)', opacity: 0.6 }} />
        </div>
        <div aria-hidden className="absolute inset-0 -z-10" style={{ overflow: 'hidden' }}>
          <div style={{
            position: 'absolute', left: 0, top: 0, right: 0, bottom: 0,
            background: 'radial-gradient(ellipse at center, rgba(255,255,255,0.02) 0%, transparent 40%), radial-gradient(ellipse at 10% 20%, rgba(239,167,79,0.04) 0%, transparent 30%)'
          }} />
          <div style={{position: 'absolute', inset: 0, pointerEvents: 'none'}}>
            <div style={{width: '2px', height: '2px', boxShadow: '0 0 2px rgba(255,255,255,0.85)', opacity: 0.9}} />
          </div>
        </div>

        <div className="border-2 pb-8 md:pb-12" style={{ borderColor: '#EFA74F', borderRadius: 16, boxShadow: '0 40px 120px rgba(0,0,0,0.25), inset 0 0 30px rgba(239,167,79,0.06)', backgroundColor: 'rgba(16,10,6,0.06)' }}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-8 md:p-12 items-start">
            <div className="md:col-span-2">
              <h1 className="text-5xl md:text-7xl font-bold mb-6" style={{ color: '#EFA74F', fontFamily: 'Zeitmax, system-ui, sans-serif' }}>За БЕСТ</h1>

              <p className="text-xl md:text-2xl mb-6 leading-relaxed" style={{ color: '#DFC293', fontFamily: 'Sagewold, system-ui, sans-serif' }}>
                Од 1989 па сè до денес БЕСТ обезбедува можности за комуникација, соработка и размена на студентите ширум Европа. Во 30 земји со вкупно 82 Локални БЕСТ Групи, БЕСТ формира студентска мрежа која е константно растечка, добро организирана, моќна и иновативна. Секојдневниот напредок се должи на околу 4800 студенти кои ентузијастички дејствуваат, а скоро 1 милион студенти се опфатени од поттикнатите настани и иницијативи.
              </p>

              {/* <div className="mb-6">
                <h3 className="text-2xl font-semibold mb-2" style={{ color: '#EFA74F', fontFamily: 'Zeitmax, system-ui, sans-serif' }}>Image Description</h3>
                <div className="w-full h-44 md:h-56 rounded-lg border-2" style={{ borderColor: '#749269', backgroundColor: '#0d0e12' }}>
                  <div className="w-full h-full flex items-center justify-center text-[#DFC293]">[Image placeholder]</div>
                </div>
              </div> */}

              <p className="text-xl md:text-2xl mb-6 leading-relaxed" style={{ color: '#DFC293', fontFamily: 'Sagewold, system-ui, sans-serif' }}>
                БЕСТ на студентите им дава можност да го прошират своето знаење за теми кои го надополнуваат нивното образование преку организирање академски курсеви, инженерски натпревари, симпозиуми за едукација, тренинзи и културни размени.
              </p>

              <p className="text-xl md:text-2xl mb-6 leading-relaxed" style={{ color: '#DFC293', fontFamily: 'Sagewold, system-ui, sans-serif' }}>
                Од друга страна, БЕСТ исто така се стреми да го прошири пазарот на трудот преку саеми за вработување и кариера, работилници, воедно и водење на интернационален центар за кариера.
              </p>

              <p className="text-xl md:text-2xl mb-6 leading-relaxed" style={{ color: '#DFC293', fontFamily: 'Sagewold, system-ui, sans-serif' }}>
                Последно, но не и најмалку важно, БЕСТ има развиено свој систем на обука, па затоа нашите членови исто така ја имаат можноста да ги подобрат своите вештини и знаења со учество на тренинзи за технички вештини и „soft skills".
              </p>

              {/* <div className="mb-6">
                <h3 className="text-2xl font-semibold mb-2" style={{ color: '#EFA74F', fontFamily: 'Zeitmax, system-ui, sans-serif' }}>Image Description</h3>
                <div className="w-full h-44 md:h-56 rounded-lg border-2" style={{ borderColor: '#749269', backgroundColor: 'rgba(13,14,18,0.04)' }}>
                  <div className="w-full h-full flex items-center justify-center text-[#DFC293] text-lg">[Image placeholder]</div>
                </div>
              </div> */}
            </div>

            <aside className="md:col-span-1">
              <div className="sticky top-28 p-6 rounded-lg border-2" style={{ borderColor: '#EFA74F', background: 'linear-gradient(180deg, rgba(106,49,10,0.05), rgba(16,10,6,0.04))' }}>
                <h4 className="text-2xl font-semibold mb-4" style={{ color: '#EFA74F', fontFamily: 'Zeitmax, system-ui, sans-serif' }}>БЕСТ во бројки</h4>
                <ul className="space-y-3 text-[#DFC293] text-lg" style={{ fontFamily: 'Sagewold, system-ui, sans-serif' }}>
                  <li>82 Локални групи</li>
                  <li>30+ земји</li>
                  <li>~4800 активни студенти</li>
                  <li>120+ интернационални настани годишно</li>
                </ul>
              </div>
            </aside>
          </div>

          {/* <div style={{ marginTop:20, display:'flex', justifyContent:'center' }}>
            <a href="#" className="inline-block mt-4 mb-6 px-6 py-3 rounded-lg font-bold" style={{ background:'#EFA74F', color:'#6A310A', textDecoration:'none' }}>Дознај повеќе</a>
          </div> */}
        </div>
      </div>

      <style>{`
        @media (max-width: 640px) {
          .best-main { padding: 0 12px; }
        }
      `}</style>
    </div>
  );
}
